"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _getResource = require("../../utilities/getResource");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    radioButton: {
      display: 'flex',
      alignItems: 'center'
    },
    formControlLabel: {
      '& > span': {
        padding: 4
      }
    }
  };
};
var CustomCheckboxGroup = /*#__PURE__*/function (_Component) {
  function CustomCheckboxGroup(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomCheckboxGroup);
    _this = _callSuper(this, CustomCheckboxGroup, [props]);
    ['selectAllCheckboxes', 'deselectAllCheckboxes'].map(function (k) {
      return _this[k] = _this[k].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(CustomCheckboxGroup, _Component);
  return (0, _createClass2["default"])(CustomCheckboxGroup, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.value !== nextProps.value || this.props.children !== nextProps.children) {
        return true;
      }
      return false;
    }
  }, {
    key: "selectAllCheckboxes",
    value: function selectAllCheckboxes() {
      this.props.selectAll();
    }
  }, {
    key: "deselectAllCheckboxes",
    value: function deselectAllCheckboxes() {
      this.props.deselectAll();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        previousValue = _this$props.previousValue,
        value = _this$props.value,
        resources = _this$props.resources,
        language = _this$props.language;
      var props = Object.assign({}, this.props);
      delete props.name;
      props.classes = Object.assign({}, this.props.classes);
      delete props.previousValue;
      delete props.classes.radioButton;
      delete props.classes.formControlLabel;
      delete props.allowSelectAll;
      delete props.deselectAll;
      delete props.selectAll;
      delete props.validatorListener;
      delete props.questionDescription;
      var previousAnswers = !previousValue ? [] : previousValue;
      var currentAnswers = !value ? [] : value;
      console.log('CheckboxValidatorElement prop', this.props.answers);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.radioButton
      }, /*#__PURE__*/_react["default"].createElement(_material.FormGroup, (0, _extends2["default"])({}, props, {
        style: {
          flexDirection: this.props.direction.toLowerCase() === 'horizontal' ? 'row' : 'column'
        }
      }), this.props.answers.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
          className: classes.formControlLabel,
          key: item.value,
          control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, null),
          value: item.value,
          groups: item.groups,
          checked: currentAnswers.indexOf(item.value) !== -1,
          label: /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              display: 'flex',
              alignItems: 'center'
            }
          }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, item.label), previousAnswers.indexOf(item.value) !== -1 && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
            color: "accent",
            style: {
              marginLeft: 8
            }
          }, (0, _getResource.getResource)(resources, language, 'Label', 'Prior Answer')))
        });
      }), this.props.allowSelectAll && /*#__PURE__*/_react["default"].createElement("div", {
        className: 'selectModifierWrapper',
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "selectAllCheckboxes",
        onClick: this.selectAllCheckboxes,
        style: {
          fontSize: '0.75rem',
          marginTop: '10px',
          marginRight: '20px',
          color: 'rgba(0, 0, 0, 0.54)',
          cursor: 'pointer'
        }
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Select All')), /*#__PURE__*/_react["default"].createElement("div", {
        className: "deselectAllCheckboxes",
        onClick: this.deselectAllCheckboxes,
        style: {
          fontSize: '0.75rem',
          marginTop: '10px',
          color: 'rgba(0, 0, 0, 0.54)',
          cursor: 'pointer'
        }
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Deselect All')))));
    }
  }]);
}(_react.Component);
CustomCheckboxGroup.propTypes = {
  previousValue: _propTypes["default"].array,
  answers: _propTypes["default"].array
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomCheckboxGroup);